import { useState, useCallback, useMemo } from 'react';
import { useZusUserConnectedStore } from '@/helpers/user-auth.js';
import { useZusHomeStore } from '@/helpers/context';
import { serverLogout } from '@/helpers/common';
import { nanoid } from 'nanoid';

export const useHeaderState = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);

  const zusIsAuthenticated = useZusUserConnectedStore((state) => state.isAuthenticated);
  const setDisconnect = useZusUserConnectedStore((state) => state.setDisconnect);
  const userAuthOpenModal = useZusUserConnectedStore((state) => state.userAuthOpenModal);
  const userConnected = useZusUserConnectedStore((state) => state.userData);
  const headerBackground = useZusHomeStore((state) => state.headerBackground);
  const checkAtLeastOnce = useZusUserConnectedStore((state) => state.checkAtLeastOnce);
  const comefrom = useZusUserConnectedStore((state) => state.comefrom);

  const isAuthenticated = useMemo(() => 
    zusIsAuthenticated && checkAtLeastOnce && userConnected,
    [zusIsAuthenticated, checkAtLeastOnce, userConnected]
  );

  const disconnect = useCallback(() => {
    serverLogout();
    setDisconnect();
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
  }, [setDisconnect]);

  const openLogin = useCallback(() => {
    userAuthOpenModal('login');
  }, [userAuthOpenModal]);

  const onClickAddSpace = useCallback(() => {
    useZusUserConnectedStore.setState({ 
      what: `clickonaddspacefromheaderaddspacefrombecomehost${nanoid()}` 
    });
  }, []);

  const handleMenuToggle = useCallback((menuState, setMenuState) => {
    if (menuState) {
      setMenuState(false);
    } else {
      setOpen(false);
      setOpen2(false);
      setOpen3(false);
      setMenuState(true);
    }
  }, []);

  return {
    open,
    setOpen,
    open2,
    setOpen2,
    open3,
    setOpen3,
    isAuthenticated,
    userConnected,
    headerBackground,
    comefrom,
    disconnect,
    openLogin,
    onClickAddSpace,
    handleMenuToggle
  };
}; 